import { jsx as _jsx } from "react/jsx-runtime";
import { FunctionalLoader } from 'seagull';
export function RouteSuspenseFallback() {
    return /*#__PURE__*/ _jsx(FunctionalLoader, {
        name: "route-suspense",
        show: true
    });
}
